<template>
	<div class="cellpuri">
		<PageBanner></PageBanner>
		<div id="title" class="cellpuri_title">
			<span class="cellpuri_eng_title">Cellpuri</span> 一次性细胞富集芯片
		</div>
		<SectionDivider class="progress" id="title"></SectionDivider>
		<div class="cellpuri_container">
			<img src="../assets/img/index/黄色背景图3.jpg" class="y_img3" />
			<p class="p1">一次性细胞富集芯片</p>
			<p class="p2">Cellpuri</p>
			<p class="p3">Cellpuri是一款一次性芯片，不用离心方法实现细胞的富集。<br>
				利用细胞悬浮液通过微通道内的流变现象分离细胞，过滤掉废培养基，<br>
				并在出口收集富集的细胞。</p>
			<img src="../assets/img/production/Cellpuri_2.png" class="cellpuri_img" />
		</div>
		<p class="exp3">Cellpuri是一款一次性芯片，不用离心方法实现细胞的富集。
			利用细胞悬浮液通过微通道内的流变现象分离细胞，过滤掉废培养基，
			并在出口收集富集的细胞。</p>
		<div id="title" style="display: flex; align-items: center;margin-top: 7vh;">
			<img src="../assets/img/production/图标1.png" class="icon1" />
			<p style="font-size: 30px; font-weight: 500;margin-left: 10px;">主要特点</p>
		</div>
		<p id="title" class="maintext">无过滤器过滤技术（FLF技术）</p>
		<p id="title" class="subtext" style="line-height: 2rem;text-indent: 2em;">
			Curiosis开发的一种基于微流控芯片的细胞分离浓缩技术。芯片内部无数µm大小的通道产生了一种流变行为，可以从溶液中分离、浓缩和<br class="br">
			去除特定尺寸的颗粒。微通道的设计原理是根据细胞的大小来分离细胞，其中较大的细胞被引导到一侧，而较小的细胞在横轴上随机流动，<br class="br">
			最终聚集在另一侧。FLF技术可应用于细胞富集、白细胞分离和血浆分离。</p>
		<div class="img_container36">
			<img src="../assets/img/production/36.png" class="img_36" />
		</div>
		<p id="title" class="maintext">降低细胞损伤和结团率</p>
		<ul id="title" class="subtext" style="line-height: 40px;">
			<li>Cellpuri无需离心分离即可有效地从培养基中分离HL-60，初始浓度为4.9 x 105cells/mL的HL-60细胞，经过本产品后，可观察到<br class="br">
				细胞浓缩度超过20倍的富集细胞（121.2 x105cells/mL）。</li>
			<li>贴壁细胞(比如 MCF7 细胞)，在细胞传代过程中往往会凝聚结团。如上图所示， 使用 Cellpuri 进行富集可减少细胞结团，而离心<br class="br">
				会沉沉淀胞，从而增加了结团细胞。</li>
		</ul>
		<div class="img_container37" style="margin-top: 5vh;">
			<img src="../assets/img/production/37.png" class="img_37"/>
		</div>

		<div class="img_container38">
			<img src="../assets/img/production/38.png" class="img_38"/>
		</div>
		<p id="title" class="maintext" style="margin-top: 10vh;">用户友好的功能</p>
		<ul id="title" class="subtext" style="line-height: 40px;">
			<li>一次性富集芯片</li>
			<li>2分钟内实现富集细胞20次</li>
			<li>无离心工作流程最大限度地减少细胞损伤</li>
			<li>细胞洗涤回收率达95%</li>
			<li>使用注射泵自动处理减少人为误差</li>
		</ul>
		<div class="img_container39">
			<img src="../assets/img/production/39.png" class="img_39" />
		</div>
		<div id="title" style="display: flex; align-items: center;" class="text_7">
			<img src="../assets/img/production/图标1.png" style="width: 33px;height: auto;" />
			<p style="font-size: 25px;font-weight: bold;margin-left: 10px;">更多设备信息</p>
		</div>
		<p id="title" class="subtext" style="margin-bottom: 10vh;text-indent: 2em;">想了解更多产品信息请关注下方官网微信公众号、视频号。</p>
	</div>

</template>

<script>
	import PageBanner from '../components/public/PageBanner.vue'
	import SectionDivider from '../components/public/SectionDivider.vue'
	import scrollReveal from '../mixins/scrollReveal'
	export default {
		name: 'Cellpuri',
		components: {
			PageBanner,
			SectionDivider
		},
		mixins: [scrollReveal],
		revealSelectors: ".cellpuri_container, .img_container36, .img_container37, .img_container38, .img_container39"
	}
</script>

<style scoped>
	#title {
		margin-left: calc(50% - 600px);
	}

	.maintext {
		font-size: 30px;
		font-weight: 700;
	}

	.subtext {
		font-size: 18px;
	}

	.cellpuri_container {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		transform: translateY(200px);
		transition: transform .5s ease, opacity .5s ease;
		opacity: 0;
	}

	.y_img3 {
		margin-top: 20px;
		height: 400px;
		width: 1200px;
	}

	.cellpuri_container p {
		position: absolute;
	}

	.cellpuri_container .p1 {
		margin-right: 700px;
		margin-bottom: 200px;
		font-size: 28px;
	}

	.cellpuri_container .p2 {
		margin-right: 770px;
		margin-bottom: 100px;
		font-size: 50px;
		font-family: Rany Bold;
		font-weight: 700;
	}

	.cellpuri_container .p3 {
		margin-right: 400px;
		margin-top: 200px;
		font-size: 18px;
		line-height: 2;
	}

	.cellpuri_img {
		position: absolute;
		width: auto;
		height: 300px;
		margin-left: 700px;
	}

	.img_36 {
		width: 860px;
		height: 484px;
	}

	.img_39 {
		width: 510px;
		height: 480px;
		position: absolute;
		margin-left: 50vw;
		margin-bottom: 10vh;
	}

	.img_container36, .img_container37, .img_container38, .img_container39 {
		display: flex;
		justify-content: center;
		align-items: center;
		transform: translateY(200px);
		transition: transform .5s ease, opacity .5s ease;
		opacity: 0;
	}

	.content-center {
		transform: translateY(0);
		opacity: 1;
	}

	.cellpuri_title {
		font-size: 2em;
		margin-top: 6vh;
		letter-spacing: 1px;
	}

	.cellpuri_eng_title {
		font-family: Rany;
		font-weight: 600;
		font-size: 30px;
	}

	.progress {
		width: 200px;
		margin-top: 10px;
		margin-bottom: 5vh;
	}

	.exp3 {
		display: none;
	}

	.icon1 {
		width: 33px;
		height: auto;
	}

	.text_7 {
		margin-top: 30vh;
	}

	@media screen and (max-width: 1150px) {
		#title {
			margin-left: calc(50% - 450px);
		}

		.y_img3 {
			margin-top: 20px;
			height: auto;
			width: 100%;
		}

		.cellpuri_container .p1 {
			margin-right: 580px;
			font-size: 1.5rem;
		}

		.cellpuri_container .p2 {
			margin-right: 680px;
			font-size: 2rem;
		}

		.cellpuri_container .p3 {
			margin-right: 300px;
			font-size: 1rem;
			margin-top: 150px;
		}

		.cellpuri_img {
			width: auto;
			height: 250px;
			margin-left: 550px;
		}

		.img_36 {
			width: 800px;
			height: 444px;
		}

		.img_39 {
			width: 450px;
			height: 420px;
			margin-left: 500px;
		}
	}

	@media screen and (max-width: 800px) {
		#title {
			margin-left: calc(50% - 180px);
		}

		.maintext {
			font-size: 25px;
		}

		.cellpuri_title {
			font-size: 1.1rem;
			margin-top: 5vh;
		}

		.cellpuri_eng_title {
			font-weight: 500;
			font-size: 1.1rem;
		}

		.progress {
			width: 120px;
			margin-top: 10px;
		}

		.y_img3 {
			margin-top: 20px;
			height: calc(180px + 10vw);
			width: 100%;
		}

		.cellpuri_container .p1, .cellpuri_container .p2 {
			font-size: 1.2rem;
			margin-right: 200px;
			margin-top: 160px;
		}

		.cellpuri_container .p3 {
			display: none;
		}

		.exp3 {
			display: block;
			margin-right: 30px;
			margin-left: 30px;
			font-size: 1rem;
			line-height: 2;
			text-indent: 2em;
		}

		.cellpuri_img {
			position: absolute;
			height: 150px;
			width: auto;
			margin-top: 20px;
			margin-left: 200px;
		}

		.icon1 {
			width: 25px;
			height: auto;
		}

		.img_36, .img_37, .img_38 {
			width: 380px;
			height: auto;
		}

		.img_39 {
			width: 380px;
			height: auto;
			position: relative;
			margin-left: 0;
			margin-bottom: 0;
		}

		.subtext {
			margin-right: 20px;
			line-height: 2rem;
		}

		.br {
			display: none;
		}

		.text_7 {
			margin-top: 100px;
		}
	}
</style>